import styled from "styled-components";

const theme = {
  bg: "#121212",
  surface: "#1E1E1E",
  gold: "#D4AF37",
  text: "#FFFFFF",
  textSecondary: "#A9A9A9",
  border: "#333333",
};

// --- ESTRUTURA BASE DO MODAL ---
export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;
export const ModalBox = styled.div`
  background-color: ${theme.surface};
  color: ${theme.text};
  border-radius: 16px;
  width: 90%;
  max-width: 800px;
  height: 90%;
  max-height: 800px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  border: 1px solid ${theme.border};
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;
export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 16px;
`;
export const Header = styled.header`
  padding: 20px 25px;
  border-bottom: 1px solid ${theme.border};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;
export const Title = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  color: ${theme.gold};
`;
export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  color: ${theme.textSecondary};
  cursor: pointer;
  line-height: 1;
  &:hover {
    color: ${theme.text};
  }
`;

// --- CONTEÚDO PARA PDF E ASSINATURA ---
export const ModalPDFContainer = styled.div`
  flex-grow: 1; /* Faz o container do PDF ocupar todo o espaço disponível */
  overflow-y: auto;
  background-color: #fff; /* Fundo branco para o PDF */
  color: #333; /* <-- ADICIONE ESTA LINHA PARA TORNAR O TEXTO ESCURO */
`;

export const Footer = styled.footer`
  padding: 20px 25px;
  border-top: 1px solid ${theme.border};
  background-color: ${theme.surface};
  flex-shrink: 0;
`;
export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  label {
    font-size: 1rem;
    color: ${theme.textSecondary};
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  input {
    margin-right: 10px;
    cursor: pointer;
    width: 18px;
    height: 18px;
  }
`;
export const ConfirmButton = styled.button`
  width: 100%;
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  border: none;
  background: ${theme.gold};
  color: ${theme.surface};
  transition: all 0.3s ease;
  &:hover:not(:disabled) {
    background: #eacd65;
    transform: translateY(-3px);
  }
  &:disabled {
    background-color: ${theme.border};
    color: ${theme.textSecondary};
    cursor: not-allowed;
  }
`;

// --- CONTEÚDO PARA SALDO INSUFICIENTE ---
export const Content = styled.div`
  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`;
export const InsufficientBalanceBox = styled.div`
  text-align: center;
  max-width: 400px;
`;
export const Icon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;
export const InsufficientTitle = styled.h3`
  font-size: 1.8rem;
  color: #e74c3c;
  margin: 0 0 0.5rem 0;
`;
export const InsufficientText = styled.p`
  font-size: 1rem;
  color: ${theme.textSecondary};
  line-height: 1.6;
  margin-bottom: 2rem;
`;
export const InfoSection = styled.div`
  background-color: ${theme.bg};
  padding: 20px;
  border-radius: 12px;
  border: 1px solid ${theme.border};
  margin-bottom: 2rem;
`;
export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
`;
export const InfoLabel = styled.span`
  font-size: 1rem;
  color: ${theme.textSecondary};
`;
export const InfoValue = styled.span`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${(props) => props.color || theme.text};
`;
export const BackButton = styled.button`
  width: 100%;
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  background: transparent;
  color: ${theme.gold};
  border: 2px solid ${theme.gold};
  transition: all 0.3s ease;
  &:hover {
    background: ${theme.gold};
    color: ${theme.surface};
  }
`;
